import { WritableDraft } from 'immer';
import ActivityAlertLevel from '../../../enums/activities/ActivityAlertLevel';
import ActivityStatus from '../../../enums/activities/ActivityStatus';
import { AgentInboxItem, AgentInboxItemStore } from '../stores/useAgentInboxItemStore';

export function applyOrder(state: WritableDraft<AgentInboxItemStore>, insertIntoArrays?: boolean) {
  const { newReply, rest, specialStatusList } = sortActivitiesByPriority(
    Array.from(state.activityMap.values()),
    state.sortByReceived
  );
  function modifyMapOrder(item: AgentInboxItem, idx: number, dataMap: Map<number, AgentInboxItem>) {
    const exists = dataMap.get(item.value.Id);
    if (exists && exists?.order != idx) {
      dataMap.set(item.value.Id, {
        ...exists,
        order: idx
      });
    }
  }

  newReply.forEach((item, idx) => {
    modifyMapOrder(item, idx, state.activityMap);
    if (!insertIntoArrays) return;
    state.replies.push(item.value.Id);
  });
  rest.forEach((item, idx) => {
    modifyMapOrder(item, idx, state.activityMap);
    if (!insertIntoArrays) return;
    if (item.value.HasUnprocessedFollowUps) {
      state.followUpActive.push(item.value.Id);
      if (!item.value.HasNewReply) {
        return;
      }
    }
    state.active.push(item.value.Id);
    return;
  });
  specialStatusList.forEach((item, idx) => {
    modifyMapOrder(item, idx, state.activityMap);
    if (!insertIntoArrays) return;
    if (item.value.HasUnprocessedFollowUps) {
      state.followUpInactive.push(item.value.Id);
      //return;
    }
    state.inactive.push(item.value.Id);
  });
}

const sortActivitiesByPriority = (array: Array<AgentInboxItem>, sortByReceived?: boolean) => {
  const arraySliced = array.slice();
  const specialStatuses = [ActivityStatus.Waiting, ActivityStatus.Holding];
  const specialStatusList = sortByPriorityInternal(
    arraySliced.filter((a) => specialStatuses.includes(a.value.ActivityStatus)),
    sortByReceived
  );
  const newReply = sortByPriorityInternal(
    arraySliced.filter((a) => a.value.HasNewReply && !specialStatuses.includes(a.value.ActivityStatus)),
    sortByReceived
  );
  const rest = sortByPriorityInternal(
    arraySliced.filter((a) => !a.value.HasNewReply && !specialStatuses.includes(a.value.ActivityStatus)),
    sortByReceived
  );
  return { newReply, rest, specialStatusList }; //[...newReply, ...rest, ...specialStatusList];
};

const sortByPriorityInternal = (array: Array<AgentInboxItem>, sortByReceived?: boolean) => {
  const order = [
    ActivityAlertLevel.None,
    ActivityAlertLevel.Upcoming,
    ActivityAlertLevel.Tomorrow,
    ActivityAlertLevel.Today,
    ActivityAlertLevel.Urgent
  ];

  return array.sort((a, b) => {
    if (sortByReceived) {
      // When sortByReceived is true: Primary sort by received date, secondary by alert level
      const dateA = a.value.InitialEmailReceivedDate ? new Date(a.value.InitialEmailReceivedDate).getTime() : 0;
      const dateB = b.value.InitialEmailReceivedDate ? new Date(b.value.InitialEmailReceivedDate).getTime() : 0;
      return dateB - dateA;
    }

    // Default behavior: Alert level only
    const indexA = order.indexOf(a.value.ActivityAlertLevel);
    const indexB = order.indexOf(b.value.ActivityAlertLevel);
    return indexB - indexA;
  });
};
//goes through all "groups" to inject the new value into it
export function clearInboxArrays(state: WritableDraft<AgentInboxItemStore>) {
  state.active = [];
  state.inactive = [];
  state.replies = [];
  state.followUpActive = [];
  state.followUpInactive = [];
}
